var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 5 3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 3,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.67,
    height: 3,
    fill: "#002395"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.67,
    height: 3,
    x: 3.33,
    fill: "#ED2939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFr);
export default __webpack_public_path__ + "static/media/flag-fr.af456d45c6307218138dfb70a02b6a18.svg";
export { ForwardRef as ReactComponent };